import { sendToBusinessCentral } from "../utils/businessCentralUtils";
import { addCampaign, cleanupCampaigns } from "./campaignService";

// Función para sincronizar campañas desde Business Central
export const syncCampaigns = async () => {
    try {
        console.log("Iniciando sincronización de campañas...");

        // Obtener datos de Business Central
        const response = await sendToBusinessCentral("Importaciones_getactiveCampaigns", {}, true);

        if (!response || !response.value) {
            console.log("No se pudo obtener respuesta del servidor de campañas");
            return false;
        }

        const data = JSON.parse(response.value);

        // Limpiar campañas existentes
        await cleanupCampaigns();

        // Procesar campañas activas
        if (data.Active_Campaings && data.Active_Campaings.length > 0) {
            console.log(`Procesando ${data.Active_Campaings.length} campañas...`);

            for (const campaign of data.Active_Campaings) {
                console.log(`Agregando campaña: ${campaign.No} - ${campaign.Description}`);
                await addCampaign({
                    No: campaign.No,
                    Description: campaign.Description,
                    Starting_Date: campaign.Starting_Date,
                    Ending_Date: campaign.Ending_Date,
                    Sales_Prices: JSON.stringify(campaign.Sales_Prices || []),
                    Line_Discounts: JSON.stringify(campaign.Line_Discounts || []),
                });
            }

            console.log(`${data.Active_Campaings.length} campañas sincronizadas correctamente`);
        } else {
            console.log("No se encontraron campañas activas en la respuesta");
        }

        return true;
    } catch (error) {
        console.error("Error al sincronizar campañas:", error);
        return false;
    }
};
